import React from 'react';
import Styles from './styles.module.scss';
import { connect } from 'react-redux';
import { ExecuteRequest } from 'core/glambox/GlamboxApi';
import { GlamboxEndpoints } from 'core/glambox/GlamboxEndpoints';
import { CopyToClipBoard } from '../../../utils/CopyToClipBoard';
import { UiActions } from 'state/actions/UiActions';

import { Helmet } from 'react-helmet';
import { PrimaryPinkButton } from 'components/buttons/PrimaryPinkButton';
import { AiFillFolderOpen } from 'react-icons/ai';

class DivulgacaoGlamshop extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      collections: null,
      comissions: null,
      person: this.props.person.person,
    };
  }

  componentDidMount() {
    // this.getCollections();
    this.getComissions();
  }

  getCollections = () => {
    const token = this.props.token.Authorization;

    ExecuteRequest(
      GlamboxEndpoints.Glamshop.getCollections,
      null,
      'GET',
      {
        Authorization: token,
      },
      null,
      response => {
        let { result, statusCode } = response;

        if (statusCode === 200) {
          this.setState({
            collections: JSON.parse(result.result),
          });
        }
      }
    );
  };

  getComissions = () => {
    ExecuteRequest(
      GlamboxEndpoints.Partner.getCurrentComissions,
      null,
      'GET',
      {
        Authorization: this.props.token.Authorization,
      },
      null,
      response => {
        const { statusCode, result } = response;
        if (statusCode === 200) {
          this.setState({
            comissions: result.result,
          });
        }
      }
    );
  };

  //--------------------------------------------------------

  copyCouponToClipboard = (id, props) => {
    CopyToClipBoard.copyToClipBoard(id, props);
  };

  _renderCollections(collection, comissions) {
    return (
      <div key={collection} className={Styles['card-product']}>
        <div className={Styles['card-header']}>
          <img
            src={require('assets/img/glampartner/gs-banner-produtos.jpg')}
            alt="Banner"
          />
        </div>
        <div className={Styles['card-body']}>
          <div className={Styles['horizontal-box']}>
            <div className={Styles['descount-card']}>
              <span>
                Desconto para seguidoras usando <br />o seu cupom:
              </span>
              <strong>{collection.desconto}%</strong>
            </div>
            <div className={Styles['descount-card']}>
              <span>
                Sua comissão por venda com <br />o seu cupom:
              </span>
              <strong>{comissions.glamshopValue * 100}%</strong>
            </div>
          </div>

          <small className={Styles['obs']}>
            O seu cupom de desconto é válido para todos os produtos da Glamshop!
          </small>
        </div>
        <div className={Styles['card-footer']}>
          <a
            href="https://glamshop.com.br/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <PrimaryPinkButton>Ver Produtos</PrimaryPinkButton>
          </a>
        </div>
      </div>
    );
  }

  render() {
    const { comissions } = this.state;

    if (!comissions) return null;

    return (
      <div id={Styles['glampartner-products']}>
        <Helmet>
          <title>Portal Glampartners: Vender produtos no Glamshop</title>
        </Helmet>

        <div id={Styles['section-products']}>
          <div className={Styles['container']}>
            <h1>Produtos</h1>
            <p>
              O uso do seu cupom para a venda de produtos da Loja oficial da Glambox também garante uma 
              comissão para você, além de um desconto especial para suas seguidoras.
            </p>
          </div>
        </div>

        <div id={Styles['section-coupon']}>
          <div className={Styles['container']}>
            <h1>Divulgue seu cupom</h1>
            <p>e ganhe comissão</p>
            <div className={Styles['coupon']}>
              <span id="first-coupon">{this.state.person?.couponName}</span>
              <PrimaryPinkButton
                type="button"
                onClick={() =>
                  this.copyCouponToClipboard('first-coupon', this.props)
                }
              >
                Copiar 
              </PrimaryPinkButton>
            </div>
          </div>
        </div>

        <div id={Styles['section-dissemination-products']}>
          <div className={Styles['container']}>
            <h1>Como funciona a divulgação?</h1>
            <p>
              Temos uma variedade de produtos das melhores marcas de beleza com precinhos incríveis. 
              Basta divulgar as melhores ofertas, que são atualizadas semanalmente, nas suas redes 
              sociais junto com o seu cupom de desconto. As suas seguidoras vão amar!
            </p>

              <div className={Styles['comission_cards']}>
                  <div className={Styles['comission_cards_coupon_usage']}>
                      <p> Desconto para seguidoras usando o seu cupom<br/><br/>
                      <h3 className={Styles['percent']}>5%</h3>
                      </p>
                  </div>

                  <div className={Styles['comission_cards_sale']}>
                  <p> Sua comissão por venda com o seu cupom<br/><br/>
                  <h3 className={Styles['percent']}>5%</h3>
                  </p>
                  </div>
                </div>
                <p><br/><br/>*O seu cupom de desconto é válido para todos os produtos da Loja!</p>
              </div>
        

          {/* <div className={Styles['products-card-group']}>
            {collections.map(collection =>
              this._renderCollections(collection, comissions),
            )}
          </div> */}
        </div>

 

        <div id={Styles['section-promotional-materials']}>
          <div className={Styles['container']}>
            <h1>Materiais para você divulgar produtos da Loja</h1>
            <p>
              Precisando de uma inspiração? As pastas abaixo contêm materiais em
              formatos variados e prontos para você publicar em suas redes.
              Esses conteúdos podem te ajudar a vender ainda mais os produtos e
              coleções da Loja. Boas vendas!
            </p>
          </div>
          <div className={Styles['material-cards-group']}>
            <a
              href="https://drive.google.com/drive/u/0/folders/1NReOlJaG_jWIDfFALRweDMsp8zBuyc0G"
              target="_blank"
              rel="noopener noreferrer"
              className={Styles['material-card']}
            >
              <AiFillFolderOpen size={82} color="#fe357b" />
              <div>
                <span>
                  Dicas para posts <br/>sobre a Loja!
                </span>

                <span className={Styles['know-more']}>Saiba mais</span>
              </div>
            </a>
            <a
              href="https://drive.google.com/drive/u/0/folders/1Orj2gTxCeXywOIz62JQsx2sYrtJiN0iC"
              target="_blank"
              rel="noopener noreferrer"
              className={Styles['material-card']}
            >
              <AiFillFolderOpen size={82} color="#fe357b" />
              <div>
                <span>
                  Materiais para <br/>divulgar produtos!
                </span>

                <span className={Styles['know-more']}>Saiba mais</span>
              </div>
            </a>
            <a
              href="https://drive.google.com/drive/u/0/folders/1OKXaJxd843filhavawQhgA2--q6DrjD1"
              target="_blank"
              rel="noopener noreferrer"
              className={Styles['material-card']}
            >
              <AiFillFolderOpen size={82} color="#fe357b" />
              <div>
                <span>
                  Divulgações para <br/>se Inspirar!
                </span>

                <span className={Styles['know-more']}>Saiba mais</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  person: state.person.data,
  token: state.token.data,
});

const mapDispatchToProps = dispatch => ({
  publishSuccessAlert: message => {
    dispatch(UiActions.publishSuccessAlert(message));
  },
});

DivulgacaoGlamshop = connect(
  mapStateToProps,
  mapDispatchToProps
)(DivulgacaoGlamshop);

export { DivulgacaoGlamshop };
